<template>
    <div :class="[
        'uik-divider__' + ( vertical ? 'vertical' : 'horizontal'),
        ( margin ? 'uik-divider__margin' : '')
    ]">
    </div>
</template>

<script>
export default {
    name: "UikDivider",
    props: {
        vertical: { type: Boolean, default: false },
        margin: { type: Boolean, default: false }
    }
}
</script>

<style lang="scss">
.uik-divider__horizontal {
  height: 1px;
  width: 100%;
  background: $borderColor;
  &.uik-divider__margin {
    margin-top: 24px;
    margin-bottom: 24px;
  }
}

.uik-divider__vertical {
  width: 1px;
  height: 100%;
  background: $borderColor;
  &.uik-divider__margin {
    margin-left: 24px;
    margin-right: 24px;
  }
}
</style>
